export default "__VITE_ASSET__BGDpUIMc__"